/**
 * Sommaire d'article Wilderpad.
 * Construit la table des matières à partir des H2 réellement rendus par
 * l'éditeur d'article (H3 ignorés), puis met en surbrillance la section
 * courante. Masqué en CSS sous 990px.
 * Moins de deux H2 => la colonne sommaire se retire d'elle-même.
 */
(function () {
  'use strict';

  var SELECTOR = '.wp-article__body h2';

  function slugify(text, used) {
    var base =
      text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'section';

    var slug = base;
    var i = 2;
    while (used[slug]) slug = base + '-' + i++;
    used[slug] = true;
    return slug;
  }

  function build(root) {
    var nav = root.querySelector('[data-wp-toc]');
    var col = root.querySelector('[data-wp-toc-col]');
    if (!nav) return;

    var headings = Array.prototype.slice.call(root.querySelectorAll(SELECTOR));
    if (headings.length < 2) {
      // Un sommaire d'un seul point n'apporte rien : on retire la colonne
      // entière et la grille repasse en deux colonnes.
      root.classList.add('wp-article--no-toc');
      (col || nav).remove();
      return;
    }

    var used = Object.create(null);
    var list = document.createElement('ol');
    list.className = 'wp-toc__list';

    headings.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent, used);

      var li = document.createElement('li');
      li.className = 'wp-toc__item wp-toc__item--' + h.tagName.toLowerCase();

      var a = document.createElement('a');
      a.className = 'wp-toc__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();

      li.appendChild(a);
      list.appendChild(li);
    });

    nav.appendChild(list);
    spy(headings, nav);
  }

  function spy(headings, nav) {
    if (!('IntersectionObserver' in window)) return;

    var links = {};
    nav.querySelectorAll('.wp-toc__link').forEach(function (a) {
      links[a.getAttribute('href').slice(1)] = a;
    });

    var visible = new Set();

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visible.add(entry.target.id);
          else visible.delete(entry.target.id);
        });

        // Le premier titre visible dans l'ordre du document gagne.
        var current = null;
        for (var i = 0; i < headings.length; i++) {
          if (visible.has(headings[i].id)) {
            current = headings[i].id;
            break;
          }
        }

        Object.keys(links).forEach(function (id) {
          links[id].classList.toggle('is-current', id === current);
        });
      },
      { rootMargin: '-80px 0px -70% 0px', threshold: 0 }
    );

    headings.forEach(function (h) {
      observer.observe(h);
    });
  }

  function init() {
    document.querySelectorAll('[data-wp-article]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Le thème réinjecte la section au fil des modifications dans l'éditeur.
  document.addEventListener('shopify:section:load', init);
})();
